import {Box, Clickable, Icon, Text, ThemeColorPath, ThemeIconKey} from 'platform/foundation';
import {cn, cva} from 'platform/shared';
import {match} from 'ts-pattern';

import {dec} from 'ramda';

import {DocumentPreviewPage} from '../types/DocumentPreviewPage';
import {UseDocumentPreviewReturnType} from '../types/UseDocumentPreviewReturnType';

interface DocumentPreviewThumbnailsItemProps {
  isActive: boolean;
  documentPage: DocumentPreviewPage;
  documentPreview: UseDocumentPreviewReturnType;
}

const thumbnailBackgroundVariants = cva(
  'relative h-[140px] w-[86px] rounded-[var(--radius-small)] p-[6px]',
  {
    variants: {
      isActive: {
        true: 'bg-[var(--color-palettes-neutral-100-100)]',
        false: '',
      },
    },
  }
);

const thumbnailContentVariants = cva('flex flex-col items-center justify-center gap-[6px]');
const thumbnailVariants = cva('h-[106px] w-[74px] overflow-hidden rounded-[var(--radius-x-small)]');
const thumbnailIconVariants = cva('absolute top-2 right-2');
const thumbnailImageVariants = cva('h-full w-full rounded-[var(--radius-x-small)] object-cover');

export function DocumentPreviewThumbnailsItem(props: DocumentPreviewThumbnailsItemProps) {
  const documentPageIcon = match(props.documentPage.validationStatus)
    .returnType<ThemeIconKey>()
    .with('default', () => 'action/check_circle')
    .with('success', () => 'action/check_circle')
    .with('warning', () => 'alert/error')
    .with('error', () => 'alert/error')
    .otherwise(() => 'action/check_circle');

  const documentPageIconColor = match(props.documentPage.validationStatus)
    .returnType<ThemeColorPath>()
    .with('default', () => 'palettes.neutral.60.100')
    .with('success', () => 'severity.success')
    .with('warning', () => 'severity.warning')
    .with('error', () => 'severity.danger')
    .otherwise(() => 'palettes.neutral.60.100');

  return (
    <Clickable
      onClick={() =>
        props.documentPreview.controls.setActiveIndex(dec(props.documentPage.pageNumber))
      }
    >
      <div className={cn(thumbnailBackgroundVariants({isActive: props.isActive}))}>
        <div className={cn(thumbnailContentVariants())}>
          <div className={cn(thumbnailVariants())}>
            <>
              <div className={cn(thumbnailIconVariants())}>
                <Icon value={documentPageIcon} color={documentPageIconColor} size={3} />
              </div>
              <img
                src={props.documentPage.url}
                alt={`Thumbnail for page ${props.documentPage.pageNumber}`}
                className={cn(thumbnailImageVariants())}
              />
            </>
          </div>
          <Box>
            <Text size="xxSmall" color={props.isActive ? 'white' : 'primary'} align="center">
              {props.documentPage.pageNumber}
            </Text>
          </Box>
        </div>
      </div>
    </Clickable>
  );
}
